import type { FileAsset, FolderAsset } from 'models';
import { Button, type ColumnsType, Loading, Row, Table, type TableSorterResult } from 'ui';
import { AssetsTableEmptyState } from '../assets-table-empty-state';

type AssetItem = FileAsset | FolderAsset;

type P = {
  canManage: boolean;
  columns: ColumnsType<AssetItem>;
  communityId?: string;
  fetchNextPage: () => Promise<unknown>;
  files: AssetItem[];
  hasNextPage: boolean;
  isFetching: boolean;
  isFetchingNextPage: boolean;
  isLoading: boolean;
  onChange: (tableSorter: TableSorterResult<AssetItem>) => void;
  onRow: (record: AssetItem) => { onClick: () => void };
  parentId?: string;
  programId?: string;
};

const AssetsTableContent = ({
  canManage,
  columns,
  communityId,
  fetchNextPage,
  files,
  hasNextPage,
  isFetching,
  isFetchingNextPage,
  isLoading,
  onChange,
  onRow,
  parentId,
  programId,
}: P) => {
  if (isLoading && files.length === 0) {
    return (
      <Row align="middle" justify="center">
        <Loading />
      </Row>
    );
  }

  if (files.length === 0) {
    return (
      <AssetsTableEmptyState
        canManage={canManage}
        communityId={communityId}
        parentId={parentId}
        programId={programId}
      />
    );
  }

  return (
    <>
      <Table
        clickableRows
        columns={columns}
        dataSource={files}
        loading={isFetching}
        onChange={(_pagination, _filters, tableSorter) => {
          onChange(tableSorter);
        }}
        onRow={onRow}
        pagination={false}
      />
      {hasNextPage && !isFetchingNextPage ? (
        <Row align="middle" justify="center">
          <Button onClick={async () => fetchNextPage()}>Show More</Button>
        </Row>
      ) : null}
    </>
  );
};

export default AssetsTableContent;
